import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as Types from '@__graphql__/types';

const defaultOptions = {} as const;
export type OrderReturnReasonsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type OrderReturnReasonsQuery = {
  magento2?: {
    customAttributeMetadata?: {
      items?: Array<{
        attributeCode?: string | null;
        attributeType?: string | null;
        attributeOptions?: Array<{
          label?: string | null;
          value?: string | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export const OrderReturnReasonsDocument = gql`
  query OrderReturnReasons {
    magento2 {
      customAttributeMetadata(
        attributes: [
          { attribute_code: "reason", entity_type: "rma_item" }
          { attribute_code: "reason_other", entity_type: "rma_item" }
        ]
      ) {
        items {
          attributeCode
          attributeType
          attributeOptions {
            label
            value
          }
        }
      }
    }
  }
`;

/**
 * __useOrderReturnReasonsQuery__
 *
 * To run a query within a React component, call `useOrderReturnReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderReturnReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderReturnReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderReturnReasonsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrderReturnReasonsQuery,
    OrderReturnReasonsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrderReturnReasonsQuery,
    OrderReturnReasonsQueryVariables
  >(OrderReturnReasonsDocument, options);
}
export function useOrderReturnReasonsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrderReturnReasonsQuery,
    OrderReturnReasonsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrderReturnReasonsQuery,
    OrderReturnReasonsQueryVariables
  >(OrderReturnReasonsDocument, options);
}
export type OrderReturnReasonsQueryHookResult = ReturnType<
  typeof useOrderReturnReasonsQuery
>;
export type OrderReturnReasonsLazyQueryHookResult = ReturnType<
  typeof useOrderReturnReasonsLazyQuery
>;
export type OrderReturnReasonsQueryResult = Apollo.QueryResult<
  OrderReturnReasonsQuery,
  OrderReturnReasonsQueryVariables
>;
